import { HttpResult } from 'widgets-for-react'
import * as DrupalModel from '../../../api/drupal/drupalTypes'
import { handle } from '../../../api/apiUtils'

const drupalUrl = '/api/drupal'

export const fetchBranchLocations = async (): Promise<HttpResult<DrupalModel.Location[]>> => {
  const res = await fetch(`${drupalUrl}/api/locations/all`)
  const temp = await handle<DrupalModel.Location[]>(res)
  if (temp.kind != 'result') return temp as HttpResult<DrupalModel.Location[]>
  return { ...temp, value: temp.value }
}
